import { Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class SurveyMonkeyService {
constructor(private readonly sanitizer: DomSanitizer) {}
  loadSurvey(userData) {
    const baseUrl = `https://www.surveymonkey.com/r/${userData?.survey_id}?embedded=1`;
    // const baseUrl = `https://www.surveymonkey.com/r/JZL26XS?embedded=1`;
    const params = `&user_id=${userData?.region}&user_name=${userData.name}&user_email=${userData.email}&user_phone=${userData.phone}&user_region=${userData?.region}&user_country=${userData.country}`;
    
    const fullUrl = baseUrl + params;
 console.log(fullUrl,'TESTURL');
 
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullUrl);
  }
  
}
